module.exports = __webpack_public_path__ + "img/1562422008.531deaeb.jpg";